import React from "react";
import { BottomFillIcon } from "@t8891/icon";

interface IProps {
  onClick: (e: any) => void;
  action: string;
  data: any;
  show: "region" | "color" | "paymentType" | "insurance" | "";
  setShow: any;
}

const RegionItem: React.FC<IProps> = ({ show, setShow, action, data, onClick }) => {
  return (
    <section className='w-full relative  flex items-center'>
      <div
        className={`${show === "region" || !!action ? "text-primary" : ""} flex items-center cursor-pointer`}
        onClick={() => {
          if (show === "region") return;
          setTimeout(() => {
            setShow("region");
          });
        }}
      >
        地區
        <BottomFillIcon
          size={32}
          fill={show === "region" ? `#3264FF` : `#333`}
          style={{ transform: `rotate(${show === "region" ? 180 : 0}deg)` }}
        />
      </div>
      {show === "region" && Object.keys(data).length !== 0 && (
        <div
          className='w-500 bg-[#fff] rounded-4 border-solid border-[#e8e8e8] text-[#333] text-14 pt-20 px-18 top-32 -left-110  absolute'
          style={{ boxShadow: "0px 8px 20px 0px rgba(0, 0, 0, 0.1)", zIndex: 1 }}
          id='RegionItem'
        >
          {data?.map((v, i: number) => (
            <div className='mb-20' key={i}>
              <label className='inline-block'>{v.label}</label>
              <ul className='inline-block font-normal text-[#999] cursor-pointer hover:text-[#3264ff]'>
                {v.regions.map((vv: any, ii: number) => (
                  <li
                    className={`inline-block font-normal ${
                      action === `${vv.value}` ? "text-[#3264ff]" : "text-[#999] "
                    } ml-20 cursor-pointer hover:text-[#3264ff]`}
                    key={ii}
                    onClick={() => {
                      onClick(vv);
                    }}
                  >
                    {vv.name}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      )}
    </section>
  );
};

export default RegionItem;
